import { listItemResetMixin } from '../listItemResetMixin';
import { spacingMixin } from '../spacingMixin';

/** @class ListItemMixin */
/** @method */
export var ListItemMixin = function ListItemMixin(props) {
  return [listItemResetMixin(props), spacingMixin(props)];
};